import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddGallery = () => {

  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    category_id: "",
    title: "",
    description: "",
    image: null,
    is_main: false,
  });

  const [loading, setLoading] = useState(false);

  // Fetch Categories
  const fetchCategories = async () => {
    try {
      const res = await apiFetch(
        "leader_admin/get_gallery_categories"
      );
      setCategories(res.data || []);
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

 const handleChange = (e) => {
  const { name, value, files, type, checked } = e.target;

  if (name === "image") {
    setFormData({ ...formData, image: files[0] });
  } else if (type === "checkbox") {
    setFormData({ ...formData, [name]: checked });
  } else {
    setFormData({ ...formData, [name]: value });
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const data = new FormData();
      data.append("category_id", formData.category_id);
      data.append("title", formData.title);
      data.append("description", formData.description);
      data.append("is_main", formData.is_main);

      if (formData.image) {
        data.append("image", formData.image);
      }

      await apiFetch(
        "leader_admin/insert_gallery",
        {
          method: "POST",
          body: data,
        }
      );

      alert("गॅलरी यशस्वीरित्या जोडली गेली");
      navigate("/all_gallery");

    } catch (error) {
      alert(error.message || "त्रुटी आली");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                🖼 नवीन गॅलरी जोडा (Add New Gallery Item)
              </h4>
              <small className="text-white-50">Upload photo/event to gallery</small>
            </div>
          </div>

          <Link to="/all_gallery" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Gallery List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                {/* Category */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    गॅलरी विभाग निवडा
                  </label>
                  <select
                    className="form-select"
                    name="category_id"
                    value={formData.category_id}
                    onChange={handleChange}
                    required
                  >
                    <option value="">निवडा</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    शीर्षक
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    वर्णन
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* Image Upload */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    प्रतिमा अपलोड करा
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="image"
                    accept="image/*"
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Main Event Toggle */}
<div className="col-md-6">
  <label className="form-label fw-semibold">
    मुख्य कार्यक्रम आहे का?
  </label>

  <div className="form-check form-switch mt-2">
    <input
      className="form-check-input"
      type="checkbox"
      name="is_main"
      checked={formData.is_main}
      onChange={handleChange}
    />
    <label className="form-check-label">
      मुख्य इव्हेंट म्हणून दर्शवा
    </label>
  </div>
</div>

              </div>

              <div className="mt-4 text-end">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "जतन होत आहे..." : "जतन करा"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default AddGallery;